import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/queryClient";
import { finalizePreliminary } from "@/api/endpoints/maturity";

export function useFinalizeMaturityPreliminary(sessionId: string) {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => finalizePreliminary(sessionId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeys.maturity.evaluation(sessionId),
      });
    },
  });
}
